export const BACKEND_FRAMEWORKS = [
  { label: "C#", value: 1},
  { label: "Phoenix", value: 2}
  ];

export const FRONTEND_FRAMEWORKS =[
  {label: "React", value: 1},
  {label: "LiveView", value: 2},
  {label: "None", value: 3},
];

export const DATABASES = [
  {label: "Sql Server", value: 1},
  {label: "Postgres", value: 2}
];

